"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CanalesDeComunicaciN() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const departments = [{
    number: "04",
    label: "ATENCIÓN AL PACIENTE",
    description: "Seguimiento post-intervención y soporte administrativo para nuestros pacientes.",
    email: "atencion@msinstitutocapilar.com",
    phone: "+34 626 475 620",
    contactName: "Gestión",
    contactRole: "Coordinación"
  }];
  return;
}